import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { OperationResultDTO } from '@nora-monorepo/nora-api-client';

import { useOperationConversationStore } from '#nora-ui/stores/operation-conversation-store';
import { useOperationStore } from '#nora-ui/stores/operation-store';

export const useOperationChatModalStore = defineStore(
  'operationChatModalStore',
  () => {
    const operationStore = useOperationStore();
    const showOperationChatModal = ref(false);
    const operation = ref<OperationResultDTO | undefined>();
    const operationConversationStore = useOperationConversationStore();
    const operationTitle = computed(() => operation.value?.name ?? '');

    function openOperationChatModal(currentOperationId: string): void {
      showOperationChatModal.value = true;
      const currentOperation = operationStore.findOperation(currentOperationId);
      if (!currentOperation) {
        throw new Error('Operation not found');
      }
      operation.value = currentOperation;
    }

    const closeModal = (): void => {
      showOperationChatModal.value = false;
      operation.value = undefined;
    };

    const saveOperationConversation = async (newConversationName: string): Promise<{ title: string }> => {
      newConversationName = newConversationName.trim();
      if (!newConversationName?.length) {
        throw new Error('Conversation name is required');
      }
      if (!operation.value) {
        throw new Error('Operation is required');
      }
      await operationConversationStore.createOperationConversation(
        operation.value.id,
        newConversationName,
      );
      closeModal();

      return {
        title: newConversationName,
      };
    };

    return {
      operation,
      operationTitle,
      showOperationChatModal,
      openOperationChatModal,
      closeModal,
      saveOperationConversation,
    };
  },
);
